// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CreateDependency_closeButton__FLJnh"};